'use client';

import { Button, DialogFooter, FormField, ScrollArea } from '@shared/components/shadcn';
import { Spinner } from '@shared/icons';
import { Affordability } from '@shared/icons/system';
import { useTranslations } from 'next-intl';
import { useFormContext } from 'react-hook-form';
import { useMultistepForm } from '../../../../form-controls/MultistepForm/hooks/useMultistepForm';
import { Select } from '../../../../form-controls/Select/Select';
import type { QuestionnaireStepProps } from '../types';

const IndustryStep = ({ question }: QuestionnaireStepProps) => {
  const t = useTranslations('global_dialogs.affordability_questionnaire');
  const tForm = useTranslations('form');
  const { goToNextStep, isLoading } = useMultistepForm();
  const { control, watch } = useFormContext();

  const options = question.options.map(optionKey => ({
    value: optionKey,
    text: t(optionKey),
    dataTrackValue: t(optionKey),
  }));

  const selectedOption = options.find(option => option.value === watch('industry'));

  return (
    <div className="flex min-h-0 flex-1 flex-col pt-10 md:pt-6">
      <ScrollArea className="flex min-h-0 flex-1 flex-col gap-4">
        <Affordability size="extra-extra-large" data-testid="affordability-questionnaire-icon" />
        <h4 className="mt-3">{t(question.label)}</h4>
        <div className="flex flex-col gap-4 mt-6">
          <FormField
            control={control}
            name="industry"
            render={({ field }) => (
              <Select
                {...field}
                id="industry-field"
                options={options}
                placeholder={t('select_placeholder')}
                data-testid="industry-select"
                data-track-name="Industry"
                data-track-helper="Industry"
                data-track-value={selectedOption?.dataTrackValue}
              />
            )}
          />
        </div>
      </ScrollArea>
      <DialogFooter data-track-container="Actions">
        <Button onClick={goToNextStep} disabled={isLoading} data-testid="continue-button" data-track-name="Continue" data-track-value={selectedOption?.dataTrackValue}>
          {isLoading ? <Spinner size="small" className="animate-spin w-5" aria-label={tForm('aria.loading')} /> : t('continue')}
        </Button>
      </DialogFooter>
    </div>
  );
};

export { IndustryStep };
